import axios from 'axios';

export async function getBlobFromBase64(base64: string) {
  const { data: blob } = await axios.get(base64, {
    responseType: 'blob',
  });

  return blob;
}
